import React from 'react';
import { Juridiction } from '../../../../../entity/entity.types';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from './RestrictToLawyerContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { JuridictionsChartContainer } from '../../../../../entity/charts/juridictions/JuridictionsChartContainer';
import { JuridictionsChart } from '../../../../../entity/charts/juridictions/JuridictionsChart';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { EnhanceJuridictionChart } from '../../../../../entity/charts/juridictions/EnhanceJuridictionChart';
import { ChartDecisionLegend } from '../../../../../entity/charts/legend/ChartLegend';

type Props = {
  juridictions: Array<Juridiction>;
  lawyerId: string;
  lawyerName: string;
  url: string;
  source: string;
} & PropsFromRedux &
  WithRestrictedModalProps &
  UserContextType;

class RawJuridictionTab extends React.Component<Props> {
  filterSearch = (source: string) => (
    wantToOpenInNewTab: boolean,
    juridiction: Juridiction | null,
  ) => {
    const { onRestrictToLawyer, accessPremium } = this.props;
    const clickedSource = `${this.props.source}-${source}`;
    if (accessPremium) {
      const data = {
        lawyerName: this.props.lawyerName,
        lawyerId: this.props.lawyerId,
        juridiction: juridiction ? juridiction.key : undefined,
        type: 'juridiction',
      };
      doctrineAnalytics('Search ChartSnippetClicked', data);
      onRestrictToLawyer(data);
    } else {
      this.props.openRestrictedModal(clickedSource);
    }
  };

  render() {
    return (
      <div className="enterprise-snippet__panel">
        <JuridictionsChartContainer juridictions={this.props.juridictions}>
          {({ sortedJuridictions }) => (
            <>
              <EnhanceJuridictionChart
                juridictions={sortedJuridictions}
                handleClick={this.filterSearch('juridictions_chart')}
              >
                {({ data, labels, handleClick }) => (
                  <JuridictionsChart
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                  />
                )}
              </EnhanceJuridictionChart>
              <EnhanceJuridictionChart
                juridictions={sortedJuridictions}
                handleClick={this.filterSearch('juridictions_legend')}
              >
                {({ data, labels, handleClick, baseH }) => (
                  <ChartDecisionLegend
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                    limit={3}
                    baseH={baseH}
                  />
                )}
              </EnhanceJuridictionChart>
            </>
          )}
        </JuridictionsChartContainer>
      </div>
    );
  }
}

export const JuridictionTab = withUser(
  Connect(withRestrictedModal(RawJuridictionTab)),
);
